var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "25px",
    viewBox: "0 0 5 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2761FE99-565C-47DA-BCBC-46A4881B8090") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiseIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recruiters",
    transform: "translate(-1642.000000, -123.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1680,
    height: 1066
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row-Users-Admin",
    transform: "translate(223.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1454,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "More",
    transform: "translate(1419.000000, 23.000000)",
    fill: "#ADADAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,5 C3.88071187,5 5,3.88071187 5,2.5 C5,1.11928813 3.88071187,0 2.5,0 C1.11928813,0 0,1.11928813 0,2.5 C0,3.88071187 1.11928813,5 2.5,5 Z M2.5,15 C3.88071187,15 5,13.8807119 5,12.5 C5,11.1192881 3.88071187,10 2.5,10 C1.11928813,10 0,11.1192881 0,12.5 C0,13.8807119 1.11928813,15 2.5,15 Z M2.5,25 C3.88071187,25 5,23.8807119 5,22.5 C5,21.1192881 3.88071187,20 2.5,20 C1.11928813,20 0,21.1192881 0,22.5 C0,23.8807119 1.11928813,25 2.5,25 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/MoreIcon.34cbe6f38688c24b8bef556e6b20f05d.svg";
export { ForwardRef as ReactComponent };